import { useTypeSelectors } from "./useTypeSelectors";
import { DateTime } from "luxon";
import { StationSpot } from "types/DataTypes";

export const useDisplayDashboardFilters = () => {
  const { dashboardSettings } = useTypeSelectors((state) => state.dashboard);
  const { userData } = useTypeSelectors((state) => state.auth);

  return `${returnstations(dashboardSettings.stations, userData.station_spots)}, ${returnDates(
    dashboardSettings.filterType,
    dashboardSettings.dateFilters?.date,
    dashboardSettings.dateFilters?.week,
    dashboardSettings.dateFilters?.month,
    dashboardSettings.dateFilters?.year,
  )}`;
};

export const returnstations = (
  stations: number[] | undefined,
  stationSpots: StationSpot[],
) => {
  const filteredStations = stationSpots
    .filter((spot) => stations?.includes(spot.station.id))
    .map((spot) => spot.station.title);
  if (stations && stations?.length > 3) {
    return `${filteredStations.slice(0, 3).join(", ")} + ${filteredStations.length - 3}`;
  } else {
    return filteredStations.join(", ");
  }
};

export const returnDates = (
  type: string | undefined,
  dateValue: string | undefined,
  weekValue: string | undefined,
  monthValue: string | undefined,
  yearMonth: string | undefined,
) => {
  switch (type) {
    case "date":
      return `${DateTime.fromISO(dateValue || "").toFormat("dd-MM-yyyy")} (Week ${
        DateTime.fromISO(dateValue || "")
          .plus({ days: 1 })
          .startOf("week")
          .minus({ days: 1 }).weekNumber + 1
      })`;
    case "week":
      return `Week ${weekValue?.split("-W")[1]} (${weekValue?.split("-W")[0]})`;
    case "month":
      return DateTime.fromFormat(monthValue || "", "yyyy-MM").toFormat("MMMM yyyy");
    case "year":
      return yearMonth;
    default:
      break;
  }
};
